export const API_PATH = '/api/v1/';
export const CSRF_COOKIE = 'X-CSRF-TOKEN';
export const TOKEN_COOKIE = 'X-OO_TOKEN';
export const ORIGIN_PATH = 'originalPath';
